<template>
   
 <div>
  <v-btn icon color="blue" @click="dialog = true">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
  <v-dialog v-model="dialog" max-width="500px" @click:outside="dialog = false">
        <v-card class="pad-10">
        <v-card-title class="d-flex justify-center">
          <p class="text-center">{{ name }}</p>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="6">
                <label for="">Rate Range (From)</label>
                <v-text-field color="auto" v-model="rate.min" type="number" outlined></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <label for="">Rate Range (To)</label>
                <v-text-field color="auto" v-model="rate.max" type="number" outlined></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <label for="">Charges</label>
                <v-text-field color="auto" v-model="rate.confirmation_charge" type="number" outlined></v-text-field>
           
              </v-col>
            </v-row>
            <default-button @click="updateRange" :loading="loading" >Save Edit</default-button>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
 </div>
  </template>
  
  <script>

  
import app from '@/main'
// =========== IMPORT SERVICES =============
import { CryptoService } from "@/services";


import DefaultButton from "@/components/Buttons/default-button.vue"


  export default {
    components: {

    DefaultButton
  },
    data() {
      return {
        dialog: false,
        loading: false,
      };
    },
    props: {
    rate: Object,
    name: String
  },
    methods: {
     
      async updateRange() {
      try {
        let rate = {
          id: this.rate.id,
          max: Number(this.rate.max),
          min: Number(this.rate.min),
          confirmation_charge: Number(this.rate.confirmation_charge),
        }
        this.loading = true;
        let data = await CryptoService.updateCoinRate(rate);
        if (data) {
        
          this.loading = false;
          //alert('success');
          app.$store.dispatch('toast', {
            message: 'coin rate updated',
            variant: 'success'
          })
          this.dialog = false;
          this.loading = false;

        }
      }
      catch (error) {
        this.dialog = false
      
      }

    },
    },
  };
  </script>